exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hrs-spent[data-v-0e63048c]{color:#222227;font-family:Open Sans,sans-serif;font-size:52px;font-weight:600;letter-spacing:0;line-height:55px;text-align:center}", ""]);

// exports
